/**
 * @file ppde页面的header
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useCallback} from 'react';
import {Tabs} from 'antd';
import ReactStickyPolyfill from '../../../../components/react-sticky-polyfill/ReactStickyPolyfill';

const PpdeHeader: React.FC = (props) => {
    const onTabChange = useCallback((activeKey: string) => {
        window.location.href = `/ppde#${activeKey}`;
    }, []);

    return (
        <ReactStickyPolyfill>
            <Tabs
                className="paddle-ppde-tabs"
                activeKey="PPDE成员"
                onChange={onTabChange}
            >
                <Tabs.TabPane
                    key="PPDE首页"
                    tab="PPDE首页"
                />
                <Tabs.TabPane
                    key="PPDE成员"
                    tab="PPDE成员"
                />
                <Tabs.TabPane
                    key="PPDE精选项目"
                    tab="PPDE精选项目"
                />
                <Tabs.TabPane
                    key="PPDE活动报道"
                    tab="PPDE活动报道"
                />
                <Tabs.TabPane
                    key="PPDE专属权益"
                    tab="PPDE专属权益"
                />
                <Tabs.TabPane
                    key="关于我们"
                    tab="关于我们"
                />
            </Tabs>
        </ReactStickyPolyfill>
    );
};

export default PpdeHeader;
